import React, { useState } from 'react'

export default function TextFrom(props) {
    const [text, setText] = useState('')
    const handle_onchange = (event) => {
        setText(event.target.value)
    }
    const to_uppercase = () => {
        let upprtext = text.toUpperCase()
        setText(upprtext)
        props.showAlert("Converted to uppercase!", "success");
    }
    const to_copy = () => {
        navigator.clipboard.writeText(text)
        props.showAlert("Copied to clipboard", "success");
    }
    const to_lowercase = () => {
        let lowertext = text.toLowerCase()
        setText(lowertext)
        props.showAlert("Converted to Lowercase!", "success");
    }
    const to_clear = () => {
        setText('')
        props.showAlert("Text Cleared!", "success");
    }
    const to_speak = () => {
        let msg = new SpeechSynthesisUtterance();
        msg.text = text;
        const voices = window.speechSynthesis.getVoices();
        const selectedVoice = voices.find(voice => voice.name.includes('female')) || voices[0];
        msg.voice = selectedVoice;
        window.speechSynthesis.speak(msg);
        props.showAlert("Speaks soon!", "success");
    }
    const to_downloadTxtFile = () => {
        const element = document.createElement("a");
        const file = new Blob([text], {
            type: "text/plain"
        });
        element.href = URL.createObjectURL(file);
        element.download = "myFile.txt";
        element.click();
        props.showAlert("Txt File will download soon!", "success");
    }
    const to_sentenceCase = () => {
        let inputText = text; // Assuming text is the input sentence
        let sentences = inputText.split('. ');
        let sentenceCaseText = sentences.map(sentence => {
            if (sentence.length > 0) {
                return sentence.charAt(0).toUpperCase() + sentence.slice(1);
            } else {
                return sentence;
            }
        }).join('. ');

        setText(sentenceCaseText);
        props.showAlert("Converted to sentence case!", "success");
    }
    const to_CapitalizedCase = () => {
        let inputText = text; // Assuming text is the input sentence
        let words = inputText.split(' ');
        let capitalizedText = words.map(word => {
            if (word.length > 0) {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            } else {
                return word;
            }
        }).join(' ');

        setText(capitalizedText);
        props.showAlert("Converted to Capitalized Case!", "success");
    }
    const to_CamelCase = () => {
        let inputText = text; // Assuming text is the input sentence
        let words = inputText.split(' ');
        let camelCaseText = words.map((word, index) => {
            if (word.length > 0) {
                if (index === 0) {
                    return word.toLowerCase();
                } else {
                    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                }
            } else {
                return word;
            }
        }).join('');

        setText(camelCaseText);
        props.showAlert("Converted to CamelCase!", "success");
    }
    const to_KebabCase = () => {
        let inputText = text; // Assuming text is the input sentence
        let words = inputText.split(' ');
        let kebabCaseText = words.map(word => {
            if (word.length > 0) {
                return word.toLowerCase();
            } else {
                return word;
            }
        }).join('-');

        setText(kebabCaseText);
        props.showAlert("Converted to kebab-case!", "success");
    }
    const to_SnakeCase = () => {
        let inputText = text; // Assuming text is the input sentence
        let words = inputText.split(' ');
        let snakeCaseText = words.map(word => {
            if (word.length > 0) {
                return word.toLowerCase();
            } else {
                return word;
            }
        }).join('_');

        setText(snakeCaseText);
        props.showAlert("Converted to snake_case!", "success");
    }
    const to_TitleCase = () => {
        let inputText = text; // Assuming text is the input sentence
        let words = inputText.split(' ');
        let titleCaseText = words.map(word => {
            if (word.length > 0) {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            } else {
                return word;
            }
        }).join(' ');

        setText(titleCaseText);
        props.showAlert("Converted to Title Case!", "success");
    }
    const to_invertText = () => {
        let inputText = text; // Assuming text is the input sentence
        let invertedText = inputText.split('').reverse().join('');

        setText(invertedText);
        props.showAlert("Text inverted!", "success");
    }

    const to_removeMultipleSpaces = () => {
        let inputText = text; // Assuming text is the input sentence
        let cleanedText = inputText.replace(/  +/g, ' ');

        setText(cleanedText);
        props.showAlert("Multiple spaces removed!", "success");
    }
    const to_removeAllDigits = () => {
        let inputText = text; // Assuming text is the input sentence
        let cleanedText = inputText.replace(/\d/g, '');

        setText(cleanedText);
        props.showAlert("Digits removed!", "success");
    }

    const to_slugifyText = () => {
        let inputText = text; // Assuming text is the input sentence
        let slug = inputText
            .toLowerCase()           // Convert to lowercase
            .replace(/\s+/g, '-')    // Replace spaces with hyphens
            .replace(/[^a-z0-9-]/g, '') // Remove non-alphanumeric and non-hyphen characters

        setText(slug);
        props.showAlert("Text slugified!", "success");
    }






    return (
        <>
            <div className="container" style={{ color: props.mode === 'light' ? 'black' : 'white' }}>
                <div className="mb-3">
                    <textarea value={text} onChange={handle_onchange} className={`form-control background-color-unset ${props.mode}`} id="exampleFormControlTextarea1" rows="8" style={{ backgroundColor: props.mode === 'light' ? 'white' : '#000', color: props.mode === 'light' ? 'black' : 'white' }}></textarea>
                </div>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_sentenceCase}>
                    Sentence case
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_uppercase}>
                    UPPER CASE
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_lowercase}>
                    lower case
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_CapitalizedCase}>
                    Capitalized Case
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_CamelCase}>
                    CamelCase
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_KebabCase}>
                    kebab-case
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_SnakeCase}>
                    snake_case
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_TitleCase}>
                    Title Case
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_invertText}>
                    Invert Text
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_removeMultipleSpaces}>
                    Remove Multiple Spaces
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_removeAllDigits}>
                    Remove All Digits
                </button>
                <button disabled={text.length === 0}     className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}   onClick={to_slugifyText}>
                    Slugify Text
                </button>
                <hr />
                <button disabled={text.length === 0} className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}  onClick={to_copy}>
                    Copy to Clipboard
                </button>
                <button disabled={text.length === 0} className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}  onClick={to_speak}>
                    Speak Text
                </button>
                <button disabled={text.length === 0} className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}  onClick={to_downloadTxtFile}>
                    Download Text File
                </button>
                <button disabled={text.length === 0} className={`btn mx-1 my-1 btn-sm ${props.mode === 'light' ? 'btn-outline-dark' : 'btn-outline-light'}`}  onClick={to_clear}>
                    Clear Text
                </button>
                <hr />
                {text.length > 0 && (
                    <div className="container my-3" style={{ color: props.mode === 'light' ? 'black' : 'white' }}>
                        <h3>Your Text Summary</h3>
                        <p> {text.split(/\s+/).filter((element) => { return element.length !== 0 }).length} {(text.split(' ').length === 1 || text.split(' ').length === 0) ? 'Word' : 'Words'}  and {text.length} {(text.length === 1 || text.length === 0) ? 'Character' : 'Characters'}</p>
                        <p> {text.split(' ').length * 0.008 > 1 ? Math.trunc(text.split(' ').length * 0.008) : ''} {text.split(' ').length * 0.008 > 1 ? 'Minutes to read' : text.length === 0 ? '' : 'Less then a Minute'}</p>
                        <hr />
                        <div>
                            <h2>Preview</h2>
                            <p>{text}</p>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
